import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

import { maxCount } from '../../utils/tabsHelpers';

const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 48px;
  font-family: 'Montserrat';
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px 8px 0 0;
  border: 1px solid ${themeGet('colors.black.10')};
  padding: 16px 24px;
  border-bottom: 0;

  ${variant({
    variants: {
      active: {
        color: 'primary.100',
        backgroundColor: 'white',
        ':after': {
          background: 'white',
          position: 'absolute',
          width: '100%',
          height: '1px',
          bottom: '-1px',
          left: '0',
        },
      },
      inactive: {
        color: 'black.80',
        backgroundColor: 'black.5',
      },
    },
  })}

  &:after {
    content: '';
  }

  &:first-child {
    margin-right: 8px;
  }
`;

const TilesCount = styled.span`
  border: 1px solid;
  padding: 2px 6px;
  border-radius: 30px;
  margin-left: 4px;
  min-width: 25px;
  text-align: center;

  ${variant({
    variants: {
      active: {
        borderColor: 'primary.100',
      },
      inactive: {
        borderColor: 'black.80',
      },
    },
  })}
`;

const Tab = ({ id, text, tilesAmount, activeTab, handleTabClick }) => {
  const tabVariant = activeTab === id ? 'active' : 'inactive';

  return (
    <Wrapper variant={tabVariant} onClick={() => handleTabClick(id)} id={id}>
      {text}
      <TilesCount variant={tabVariant}>{maxCount(tilesAmount)}</TilesCount>
    </Wrapper>
  );
};

Tab.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  tilesAmount: PropTypes.number.isRequired,
  activeTab: PropTypes.string.isRequired,
  handleTabClick: PropTypes.func.isRequired,
};

export default Tab;
